import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=dcb3ec4a&scoped=true&"
import script from "./Buyers.vue?vue&type=script&lang=js&"
export * from "./Buyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb3ec4a",
  null
  
)

export default component.exports